import styled from 'styled-components';

export const JobName = styled.div.attrs<{ className?: string }>({ className: 'mt-0 md:mt-2.5' })`
  color: var(--color-text);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;

  a {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    color: var(--color-text);
  }
`;
